import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { ConfirmButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import s from './AccountReactivatedModal.scss';

interface Props {
  requestClose: () => void;
}

const AccountReactivatedModal: FC<Props> = ({ requestClose }) => {
  const { t } = useTranslation();

  const onCloseModal = useCallback(() => {
    requestClose();
  }, [requestClose]);

  return (
    <MessageModal
      isOpen
      variant="horizontal"
      title={t('account.modal.reactivated.title')}
      message={t('account.modal.reactivated.message')}
      image={<div className={s['illustration']} />}
      footerButtons={[
        <ConfirmButton key="confirm" onClick={onCloseModal}>
          {t('account.modal.reactivated.button.visitProfile')}
        </ConfirmButton>,
      ]}
      onRequestClose={onCloseModal}
    />
  );
};
AccountReactivatedModal.displayName = 'AccountReactivatedModal';

export default AccountReactivatedModal;
